const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://offersshopping.com';

export default function LegalSeoJsonLd() {
  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Legal', item: `${SITE_URL}/legal` },
    ],
  };

  const privacyPolicy = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${SITE_URL}/legal#privacidad`,
    name: 'Política de Privacidad - Digital Licence Store',
    description: 'Política de privacidad de Digital Licence Store. Información sobre recopilación, uso y protección de datos personales.',
    url: `${SITE_URL}/legal`,
    inLanguage: 'es-CO',
    dateModified: '2025-01-01',
    isPartOf: { '@type': 'WebSite', name: 'Digital Licence Store', url: SITE_URL },
    breadcrumb: breadcrumb,
    about: [
      { '@type': 'Thing', name: 'Política de Privacidad' },
      { '@type': 'Thing', name: 'Términos de Servicio' },
      { '@type': 'Thing', name: 'Licencias de Software' },
      { '@type': 'Thing', name: 'Política de Reembolsos' },
    ],
    publisher: {
      '@type': 'Organization',
      name: 'Digital Licence Store',
      url: SITE_URL,
      email: 'DigitalLicenceStore@offersshopping.com',
    },
  };

  const faq = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '¿Qué datos personales recopila Digital Licence Store?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Recopilamos nombre completo, correo electrónico, información de pago procesada de forma segura, dirección IP y datos de navegación, historial de compras e información de contacto proporcionada a través de WhatsApp, Telegram o email.',
        },
      },
      {
        '@type': 'Question',
        name: '¿Cuál es la política de reembolsos de Digital Licence Store?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Si la licencia no funciona correctamente, ofrecemos reemplazo gratuito o reembolso completo. Las solicitudes deben realizarse dentro de los 30 días posteriores a la compra. No se aceptan reembolsos si la licencia ya fue activada y funciona correctamente.',
        },
      },
      {
        '@type': 'Question',
        name: '¿Las licencias de Digital Licence Store son originales?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Sí, todas las licencias vendidas en Digital Licence Store son 100% originales y están sujetas a los términos del fabricante correspondiente (Microsoft, Kaspersky, McAfee, ESET, AdGuard).',
        },
      },
      {
        '@type': 'Question',
        name: '¿Cómo puedo ejercer mis derechos sobre mis datos personales?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Para ejercer tus derechos de acceso, rectificación, eliminación, portabilidad u oposición, contáctanos a través de DigitalLicenceStore@offersshopping.com.',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(privacyPolicy) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faq) }} />
    </>
  );
}
